import React, { useState, useEffect } from 'react';
import MenuPOS from '../Menu/MenuPOS';
import POSCashManagement from './POSCashManagement';
import OrdersList from './OrdersList';
import { printTicket } from './TicketPrinter';
import { getFromStorage } from '../../utils/storage';

import LoyaltySearch from "../Loyalty/LoyaltySearch";
import LoyaltyRedeemModal from "../Loyalty/LoyaltyRedeemModal";
import LoyaltyPage from "../Loyalty/LoyaltyPage";

const POSPage = ({ menuItems, categories, sales, employees, onAddPOSSale }) => {

  const [view, setView]                     = useState('pos');
  const [cajaActiva, setCajaActiva]         = useState(null);
  const [sesionActiva, setSesionActiva]     = useState(null);
  const [currentOrderId, setCurrentOrderId] = useState(null);

  // FIX: estados loyalty
  const [loyaltyCustomer, setLoyaltyCustomer] = useState(null);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [loyaltyDiscount, setLoyaltyDiscount] = useState(0);

  useEffect(() => {
    const caja    = getFromStorage('cajaActiva', null);
    const session = getFromStorage('sesionActiva', null);

    if (
      caja && session &&
      typeof caja === "object" && typeof session === "object" &&
      caja.cajaId && caja.estado === 'abierta'
    ) {
      setCajaActiva(caja);
      setSesionActiva(session);
    } else {
      setCajaActiva(null);
      setSesionActiva(null);
      localStorage.removeItem('cajaActiva');
      localStorage.removeItem('sesionActiva');
    }

    const storedOrderId = localStorage.getItem('currentOrderId');
    if (storedOrderId) setCurrentOrderId(parseInt(storedOrderId));

    setView('pos');
  }, []);

  useEffect(() => {
    const orderId = localStorage.getItem('currentOrderId');
    if (orderId && !currentOrderId) setCurrentOrderId(parseInt(orderId));
  }, [view]);

  const handleOrderClosed = () => {
    setCurrentOrderId(null);
    // FIX: limpiar loyalty al cerrar orden
    setLoyaltyCustomer(null);
    setLoyaltyDiscount(0);
  };

  const handleSelectOrder = (orderId) => {
    setCurrentOrderId(orderId);
    localStorage.setItem('currentOrderId', orderId);
    setView('pos');
  };

  const handleOpenDrawer = (cajaData) => {
    if (!cajaData)                     { alert("Error al abrir caja."); return; }
    if (!cajaData.empleadoId)          { alert("Debes seleccionar un empleado."); return; }
    if (!cajaData.cajaId)              { alert("Error al crear la caja."); return; }
    if (cajaData.estado !== "abierta") { alert("La caja no se encuentra abierta."); return; }

    setCajaActiva(cajaData);
    localStorage.setItem('cajaActiva', JSON.stringify(cajaData));

    const newSession = {
      sesionId:        Date.now(),
      empleadoId:      cajaData.empleadoId,
      cajaId:          cajaData.cajaId,
      fechaHoraInicio: new Date().toISOString()
    };
    setSesionActiva(newSession);
    localStorage.setItem('sesionActiva', JSON.stringify(newSession));
    setView('pos');
  };

  const handleCloseDrawer = () => {
    setCajaActiva(null);
    setSesionActiva(null);
    localStorage.removeItem('cajaActiva');
    localStorage.removeItem('sesionActiva');
    setView('cash');
  };

  const cajaSales = cajaActiva
    ? (sales || []).filter(s => Number(s.drawer_id) === Number(cajaActiva.cajaId))
    : [];

  const orderSales = Object.values(
    cajaSales.reduce((acc, sale) => {
      const key = sale.order_id || sale.id;
      if (!acc[key]) {
        acc[key] = {
          order_id:       sale.order_id,
          order_number:   sale.order_number,
          payment_method: sale.payment_method,
          created_at:     sale.created_at || sale.sale_date,
          total:          0,
          items:          []
        };
      }
      acc[key].total += Number(sale.total) || 0;
      acc[key].items.push(sale);
      return acc;
    }, {})
  ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  const handleReprint = async (order) => {
    try {
      const res  = await fetch(`/api/orders/get_order_details.php?order_id=${order.order_id}`);
      const data = await res.json();
      if (!data.success) { alert('No se pudo cargar la orden'); return; }

      let ticketSettings = {};
      try {
        const sr = await fetch("https://lezen.site/api/get_ticket_settings.php", { credentials: "include" });
        const sd = await sr.json();
        ticketSettings = sd.success ? sd.data : {};
      } catch (e) {}

      const cartItems = data.items.map(item => ({
        name:         item.product_name,
        price:        Number(item.price),
        quantity:     Number(item.quantity),
        note:         item.note || '',
        variantLabel: (item.variants || []).map(v => v.variant_name).join(', ')
      }));

      const rawNum = data.order.order_number ?? order.order_id;
      const orderNumber = String(rawNum).includes('-')
        ? String(rawNum)
        : 'ORD-' + String(rawNum).padStart(6, '0');

      printTicket({
        order_id:       order.order_id,
        order_number:   orderNumber,
        order_name:     data.order.order_name || null,
        employee_name:  data.employee_name,
        total:          order.total,
        payment_method: order.payment_method,
        items:          cartItems,
        amount_paid:    order.total,
        settings:       ticketSettings
      });
    } catch (e) {
      console.error(e);
      alert('Error al reimprimir');
    }
  };

  // FIX: tab Frecuentes siempre visible, resto solo con caja abierta
  const tabs = [
    { key: 'pos',     label: 'Punto de Venta', onlyWithCaja: true  },
    { key: 'orders',  label: 'Órdenes',         onlyWithCaja: true  },
    { key: 'sales',   label: 'Ventas',           onlyWithCaja: true  },
    { key: 'cash',    label: 'Gestión de Caja',  onlyWithCaja: false },
    { key: 'loyalty', label: '⭐ Frecuentes',    onlyWithCaja: false },
  ];

  return (
    <div className="space-y-6 mt-6">

      {/* PESTAÑAS */}
      <div className="flex justify-center flex-wrap gap-2 mb-6">
        {tabs.map(tab => {
          if (tab.onlyWithCaja && (!cajaActiva || !sesionActiva)) return null;
          return (
            <button
              key={tab.key}
              onClick={() => setView(tab.key)}
              className={`${
                view === tab.key
                  ? 'bg-[#58735A] text-[#F9EFD7]'
                  : 'bg-gray-300 text-gray-700'
              } py-2 px-4 rounded-md transition duration-200`}
            >
              {tab.label}
            </button>
          );
        })}

        {/* Gestión de Caja siempre visible cuando no hay caja activa */}
        {(!cajaActiva || !sesionActiva) && (
          <button
            onClick={() => setView('cash')}
            className={`${
              view === 'cash' ? 'bg-[#58735A] text-[#F9EFD7]' : 'bg-gray-300 text-gray-700'
            } py-2 px-4 rounded-md transition duration-200`}
          >
            Gestión de Caja
          </button>
        )}
      </div>

      {/* LOYALTY SEARCH — solo en vista POS con caja abierta */}
      {view === 'pos' && cajaActiva && sesionActiva && (
        <div className="bg-white rounded-lg p-3 shadow border border-[#58735A]">

          <LoyaltySearch
            selected={loyaltyCustomer}
            onSelect={setLoyaltyCustomer}
            onClear={() => { setLoyaltyCustomer(null); setLoyaltyDiscount(0); }}
          />

          {loyaltyCustomer && loyaltyCustomer.points >= 10 && (
            <button
              onClick={() => setShowRedeemModal(true)}
              style={{
                width: "100%", padding: "8px 0", marginTop: 8,
                borderRadius: 8, border: "1px dashed #58735A",
                background: "#f0f9f0", color: "#3a5a3a",
                cursor: "pointer", fontSize: 13
              }}
            >
              ⭐ Canjear puntos ({loyaltyCustomer.points} disponibles)
            </button>
          )}

          {loyaltyDiscount > 0 && (
            <div style={{
              background: "#f0f9f0", borderRadius: 8,
              padding: "6px 12px", fontSize: 13,
              color: "#3a5a3a", marginTop: 8
            }}>
              💚 Descuento por puntos: -${loyaltyDiscount.toFixed(2)}
            </div>
          )}

          {showRedeemModal && loyaltyCustomer && (
            <LoyaltyRedeemModal
              customer={loyaltyCustomer}
              onRedeem={({ points, discount }) => {
                setLoyaltyDiscount(discount);
                setLoyaltyCustomer(prev => ({ ...prev, points: prev.points - points }));
                setShowRedeemModal(false);
              }}
              onClose={() => setShowRedeemModal(false)}
            />
          )}
        </div>
      )}

      {/* PUNTO DE VENTA */}
      {view === 'pos' && (
        cajaActiva && sesionActiva ? (
          <MenuPOS
            menuItems={menuItems}
            categories={categories}
            sesionActiva={sesionActiva}
            currentOrderId={currentOrderId}
            onOrderClosed={handleOrderClosed}
            onAddPOSSale={onAddPOSSale}
            loyaltyCustomer={loyaltyCustomer}
            loyaltyDiscount={loyaltyDiscount}
          />
        ) : (
          <div className="bg-[#F9EFD7] p-8 rounded-lg shadow text-center">
            <h2 className="text-xl font-bold text-[#3F1907] mb-4">Caja Cerrada</h2>
            <p className="text-[#3F1907] mb-6">
              Debes abrir una caja antes de poder utilizar el Punto de Venta.
            </p>
            <button
              onClick={() => setView('cash')}
              className="bg-[#58735A] hover:bg-[#3F1907] text-[#F9EFD7] py-2 px-4 rounded-md transition duration-200"
            >
              Ir a Abrir Caja
            </button>
          </div>
        )
      )}

      {/* ÓRDENES */}
      {view === 'orders' && (
        <OrdersList
          sesionActiva={sesionActiva}
          setView={setView}
          onSelectOrder={handleSelectOrder}
        />
      )}

      {/* VENTAS */}
      {view === 'sales' && (
        <div className="bg-[#F9EFD7] p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-[#3F1907] mb-4">
            Ventas de esta caja
          </h3>

          {orderSales.length === 0 ? (
            <p className="text-[#3F1907] text-sm">No hay ventas registradas en esta caja.</p>
          ) : (
            <div className="space-y-2">
              {orderSales.map((order, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-lg border border-[#58735A] p-3 flex justify-between items-center"
                >
                  <div>
                    <p className="font-semibold text-[#3F1907] text-sm">
                      {order.order_number
                        ? `ORD-${String(order.order_number).padStart(6, '0')}`
                        : `#${order.order_id}`}
                    </p>
                    <p className="text-xs text-gray-500">
                      {order.payment_method} · {
                        order.created_at
                          ? new Date(order.created_at).toLocaleTimeString('es-MX', {
                              hour: '2-digit', minute: '2-digit'
                            })
                          : '--:--'
                      }
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    <p className="font-bold text-[#3F1907]">
                      ${Number(order.total).toFixed(2)}
                    </p>
                    <button
                      onClick={() => handleReprint(order)}
                      className="text-xs bg-[#58735A] hover:bg-[#3F1907] text-[#F9EFD7] px-3 py-1.5 rounded-md transition duration-200"
                    >
                      🖨 Reimprimir
                    </button>
                  </div>
                </div>
              ))}

              <div className="pt-3 border-t border-[#58735A] flex justify-between items-center">
                <p className="text-sm font-bold text-[#3F1907]">Total de la caja</p>
                <p className="text-lg font-bold text-[#3F1907]">
                  ${orderSales.reduce((sum, o) => sum + o.total, 0).toFixed(2)}
                </p>
              </div>
            </div>
          )}
        </div>
      )}

      {/* GESTIÓN DE CAJA */}
      {view === 'cash' && (
        <POSCashManagement
          sales={sales}
          cajaActiva={cajaActiva}
          sesionActiva={sesionActiva}
          onOpenDrawer={handleOpenDrawer}
          onCloseDrawer={handleCloseDrawer}
          employees={employees}
        />
      )}

      {/* FIX: CLIENTES FRECUENTES — en el POS, no en AdminPage */}
      {view === 'loyalty' && (
        <LoyaltyPage />
      )}

    </div>
  );
};

export default POSPage;